import React from "react";
import "./entity.css";
import { Grid,Button,InputLabel,TextField,Typography, Alert} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CancelIcon from "@mui/icons-material/Cancel";
const EntityTypedrawer = ({
    error,success,addentity,handleDrawerClose,
    isAddSectionOpen,
    handleCloseErrorcode,
    handleInputChange,
    handleEditChange,
    handle_createEntity,
    handle_EditEntity,
    isEditSectionOpen,
    entityTypedata
}) => {
  return (
    <>
       <div
            style={{ padding: "20px" }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Button
                  id="back-button"
                  variant="contained"
                  color="transparent"
                  className="button_back"
                  onClick={handleDrawerClose}
                  startIcon={<ArrowBackIcon onClick={handleDrawerClose} />}
                  sx={{ textTransform: "none" }}
                >
                  Back
                </Button>
              </Grid>
              {isAddSectionOpen && (
                <>
                  <Grid item xs={12}>
                    <Typography
                      variant="h5"
                      className="font-color mb-0"
                      style={{ fontWeight: "600" }}
                    >
                      Add Entity type{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant="h7"
                      className="font-color mb-1"
                      style={{ fontWeight: "600" }}
                    >
                      Entity Type Information{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    {error && (
                      <Alert
                        variant="outlined"
                        severity="error"
                        icon={<CancelIcon onClick={handleCloseErrorcode} />}
                        className="errorAlertMaintain mt-4"
                      >
                        {error}
                      </Alert>
                    )}
                    {success && (
                      <Alert
                        variant="outlined"
                        severity="success"
                        className="sucessAlertMaintain mt-4"
                      >
                        {success}
                      </Alert>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="entity_type_name">
                      Name<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <TextField
                      id="entity_type_name"
                      size="small"
                      variant="outlined"
                      value={addentity.entity_type_name}
                      onChange={handleInputChange}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="entity_type_desc">
                      Description<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <TextField
                      id="entity_type_desc"
                      size="small"
                      multiline
                      rows={5}
                      variant="outlined"
                      value={addentity.entity_type_desc}
                      onChange={handleInputChange}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sx={{ textAlign: "right" }}>
                    <Button
                      id="back-button"
                      variant="contained"
                      color="secondary"
                      onClick={(event) => handle_createEntity(event)}
                      sx={{ textTransform: "none" }}
                    >
                      Create
                    </Button>
                  </Grid>
                </>
              )}
              {/* //////////........For Edit............////////////// */}
              {isEditSectionOpen && (
                <>
                  <Grid item xs={12}>
                    <Typography
                      variant="h5"
                      className="font-color mb-0"
                      style={{ fontWeight: "600" }}
                    >
                      Edit Entity type{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant="h7"
                      className="font-color mb-1"
                      style={{ fontWeight: "600" }}
                    >
                      Entity Type Information{" "}
                    </Typography>
                  </Grid>
                  {error && (
                    <Alert
                      variant="outlined"
                      severity="error"
                      icon={<CancelIcon onClick={handleCloseErrorcode} />}
                      className="errorAlertMaintain mt-4"
                    >
                      {error}
                    </Alert>
                  )}
                  {success && (
                    <Alert
                      variant="outlined"
                      severity="success"
                      className="sucessAlertMaintain mt-4"
                    >
                      {success}
                    </Alert>
                  )}
                  <Grid item xs={12}>
                    <InputLabel htmlFor="entity_type_name">
                      Name<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <TextField
                      id="entity_type_name"
                      size="small"
                      variant="outlined"
                      value={entityTypedata.entity_type_name}
                      onChange={handleEditChange}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="entity_type_desc">
                      Description<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <TextField
                      id="entity_type_desc"
                      size="small"
                      multiline
                      rows={5}
                      variant="outlined"
                      value={entityTypedata.entity_type_desc}
                      onChange={handleEditChange}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sx={{ textAlign: "right" }}>
                    <Button
                      id="back-button"
                      variant="contained"
                      color="secondary"
                      sx={{ textTransform: "none" }}
                      onClick={handle_EditEntity}
                    >
                      Save Changes
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </div>
    </>
  )
};

export default EntityTypedrawer;
